<template>
  <!DOCTYPE svg PUBLIC "-//W3C//DTD SVG 1.1//EN" "http://www.w3.org/Graphics/SVG/1.1/DTD/svg11.dtd">
  <svg
    version="1.1"
    id="Layer_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    width="21px"
    height="21px"
    viewBox="0 0 21 21"
    enable-background="new 0 0 21 21"
    xml:space="preserve"
  >
    <g id="icon">
      <path
        d="M7.6,3.5h6.961c2.706,0,4.9,2.294,4.9,5v0c0,2.706,-2.194,5,-4.9,5H1.5"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
      <polyline
        points="6.025,9.018 1.5,13.5 6.025,18.06"
        fill="none"
        stroke="currentColor"
        stroke-width="1"
        stroke-linecap="round"
        stroke-miterlimit="10"
        stroke-linejoin="round"
      />
    </g>
  </svg>
</template>

<script setup lang="ts"></script>
